import classNames from 'classnames'
import React from 'react'
import style from './styles/container.module.scss'

const SliderContainer = ({
  children,
  className = '',
  isSectionMargins = true,
  ...props
}): React.ReactElement => {
  return (
    <div
      className={classNames({
        [style.slider_container]: true,
        [style.slider_container_section]: isSectionMargins,
        [className]: Boolean(className)
      })}
      {...props}
    >
      {children}
    </div>
  )
}

export default SliderContainer
